<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lager']"> <i class="fa fa-building-o"></i> Lager </a>
      </li>
      <li>
        <a> Weiterverarbeitung </a>
      </li>
    </ul>
  </div>
</div>
<div class="page-content px-4 pb-2">
  <div class="bm-card bg-base-100 border border-base-300 shadow-sm rounded-md h-full overflow-auto">
    <div class="bm-card-body">
      <div class="bm-card-title">
        Offene Vorgänge
        @if (resource.isLoading()) {
          <span class="bm-loading bm-loading-spinner bm-loading-md"></span>
        }
      </div>
      <table class="bm-table bm-table-xs bm-table-zebra">
        @for (item of resource.value(); track $index) {
          <tr>
            <td class="w-0">{{ item.id }}</td>
            <td class="w-0 text-nowrap">{{ item.created_at | date: "dd.MM.yyyy HH:mm" }}</td>
            <td class="text-nowrap">
              <a [href]="getUrl(item.id)" target="_blank">Label öffnen</a>
            </td>
          </tr>
        }
      </table>
    </div>
  </div>
</div>
